import { render, staticRenderFns } from "./_addoredit.vue?vue&type=template&id=06fe27d6&"
import script from "./_addoredit.vue?vue&type=script&lang=js&"
export * from "./_addoredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports